import React, {useState} from "react";
import {CardHeader} from "@mui/material";
import {useTranslation} from "react-i18next";
import CourierManagementLayout from "../courier/courier-management-layout";
import CourierDeliveryFilters from "../courier/courier-delivery-filters";
import CourierTrackingPanel from "../courier/courier-tracking-panel";
import CourierDetailsDialog from "../courier/courier-details-dialog";

function CourierTrackingContent() {
    const {t} = useTranslation();
    const [courier, setCourier] = useState(null), [status, setStatus] = useState("");
    const [detailsId, setDetailsId] = useState(null);
    return <>
        <CardHeader title={t("CourierLiveTracking")} subheader={t("CourierLiveTrackingDescription")}/>
        <CourierDeliveryFilters courier={courier} status={status} onStatusChange={setStatus} onClearCourier={() => setCourier(null)}/>
        <CourierTrackingPanel courierId={courier?.id} status={status} onDetails={setDetailsId}
            onFilterCourier={setCourier} filterLabel="CourierTrackingFilter"/>
        {detailsId && <CourierDetailsDialog id={detailsId} onClose={() => setDetailsId(null)}/>}
    </>;
}

export default function CourierTrackingPage(props) {
    return <CourierManagementLayout {...props} activeTab="tracking"><CourierTrackingContent/></CourierManagementLayout>;
}
